<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Mailing'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-email-send-details-view [mailing]="mailing"></app-email-send-details-view>
  </mat-tab>
</mat-tab-group>
